<template>
    <el-card class="box-card">
        <div class="component-content">
            <el-tabs type="border-card" v-model="activeName" @tab-click="tabClickChange">
                <el-tab-pane label="语言包查询" name="first">
                    <el-card>
                        <div slot="header" class="clearfix">
                            <span>语言包操作</span>
                        </div>
                        <el-row>
                            <el-col :span="2">
                                <el-button size="small" type="success" @click="downloadExcel()">
                                    导出Excel
                                </el-button>
                            </el-col>
                            <el-col :span="2">
                                <el-button size="small" type="success"
                                           @click="showSyncExportDialog = true">导出json
                                </el-button>
                            </el-col>
                        </el-row>

                        <el-dialog lock-scroll center width="50%" title='导出语言包'
                                   :visible.sync="showSyncExportDialog" @close="showSyncExportDialog = false">
                            <el-table :data="exportLangType" border style="margin-top:20px;width: 100%">
                                <el-table-column prop="value" label='id'>
                                </el-table-column>
                                <el-table-column prop="label" label='语言包版本'>
                                </el-table-column>
                                <el-table-column>
                                    <template slot-scope="scope">
                                        <el-button type="danger" @click="exportJson(scope)">导出</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-input type="textarea" v-model="jsonData"></el-input>

                            <div slot="footer" class="dialog-footer">
                                <el-button @click="showSyncExportDialog = false">取消 </el-button>
                            </div>
                        </el-dialog>
                    </el-card>
                    <el-card>
                        <div slot="header" class="clearfix">
                            <span>语言包数据</span>
                        </div>
                        <el-form label-suffix=":" label-width="80px">
                            <el-form-item label="类型">
                                <el-select style="width: 700px;"  v-model="selectedType" placeholder='选中类型'>
                                    <el-option v-for="item in langTypeOptions" :key="item.key" :label="item.key + ' - ' + item.value"
                                               :value="item.key">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="内容">
                                <el-input style="width: 200px;"  v-model="langKey"
                                          placeholder='简中/繁体'></el-input>
                            </el-form-item>
                            <el-form-item label="语言类型">
                                <el-select v-model="selectedLangType" multiple placeholder='选中语言类型'>
                                    <el-option v-for="item in langType" :key="item.value" :label="item.label"
                                               :value="item.value" v-if="item.value !== 'cn'">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style="width: 50%" label="">
                                <el-button size="small" type="primary" @click="getLangConf()">查询语言
                                </el-button>
                            </el-form-item>
                        </el-form>

                        <el-table :data="dataHandled" border style="margin-top:20px;width: 100%">
                            <el-table-column prop="id" :label='$t("lang_conf.3")'>
                            </el-table-column>
                            <el-table-column prop="cn" label='简中'>
                            </el-table-column>
                            <el-table-column prop="hant" label='繁体' v-if="dataHandled.length>0 && dataHandled[0]['hant']">
                            </el-table-column>
                        </el-table>
                        <div class="pagination">
                            <el-pagination @current-change="handleCurrentChange" :current-page="currentPage"
                                           :page-size="pageSize"
                                           layout="total, prev, pager, next, jumper" :total="totalRow">
                            </el-pagination>
                        </div>
                    </el-card>
                </el-tab-pane>

                <el-tab-pane label="版本库" name="second">
                    <el-table :data="versionDataTable" border style="margin-top:20px;width: 100%">
                        <el-table-column prop="version" label='版本'>
                        </el-table-column>
                        <el-table-column prop="lang" label='语言'>
                            <template slot-scope="scope">
                                <span v-for="item in langType" v-if="scope.row.lang == item.value">{{item.label}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="lastTime" label='最近一次更新时间'>
                        </el-table-column>
                        <el-table-column label='操作'>
                            <template slot-scope="scope">
                                <el-button type="info" @click="deleteVersion(scope.row.version)">
                                    删除
                                </el-button>
                                <el-button type="success" @click="downVersionJson(scope.row.json)">
                                    下载
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
        </div>
    </el-card>
</template>

<style>
    .el-table .warning-row {
        background: #E6A23C;
    }

    .el-table .success-row {
        background: #67C23A;
    }

    .el-table .danger-row {
        background: #F56C6C;
    }
</style>

<script>
    import paginationController from '../../mixins/pagination'
    import FileSaver from 'file-saver'
    import actionConfirm from '../../mixins/action_confirm'
    import langConfApi from '../../service/lang_conf_api'
    import langVersionApi from '../../service/lang_version_api'
    import langTypes from '../../data/lang_type'
    import {
        mapState
    } from 'vuex';
    import utils from '../../lib/utils'

    export default {
        name: "langConf",
        data() {
            return {
                title: this.$route.meta.title,
                jsonData:'',
                showSyncExportDialog: false,
                selectTypes: [],
                langTypeOptions: langTypes,
                selectedType: '',
                langKey: "",
                selectedLangType: "",
                exportDataList: [{
                    id: 'cn',
                    val: '中文版本'
                }, {

                    id: 'hant',
                    val: '繁体'
                }],
                lang: 'cn',
                exportLangType:[
                    {
                        id: 1,
                        label: '中文简体',
                        val: "zh-Hans",
                        value: 'cn'
                    },
                    {
                        id: 2,
                        label: '中文繁体',
                        val: "zh-Hant",
                        value: 'hant'
                    },
                    {
                        id: 3,
                        label: '日文',
                        val: "ja-jp",
                        value: 'jp'
                    },
                    {
                        id: 4,
                        label: '英文',
                        val: "en-US",
                        value: 'en'
                    },
                    {
                        id: 5,
                        label: '海外简体',
                        val: "oversea",
                        value: 'oversea'
                    },
                    {
                        id: 6,
                        label: '韩文',
                        val: "kr",
                        value: 'kr'
                    },
                ],
                versionDataTable: [],
                activeName: 'first'
            }
        },
        mixins: [paginationController, actionConfirm],
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
            }),
        },
        mounted() {
            this.getLangs();
            // this.collectTypes();
        },
        created() {
        },
        methods: {
            tabClickChange(tab,event) {
                if (tab.name == 'second') {
                    this.getLangVersion();
                }
            },

            // 查询配置表以及最新更新时间
            collectTypes() {
                let self = this;
                langConfApi.collectTypes({
                    token: this.token
                }).then(res => {
                    self.selectTypes = res;
                })
            },
            // 查询配置表以及最新更新时间
            getLangConf() {
                let self = this;
                var lang = '';
                lang = self.selectedLangType.join(',');
                lang = 'cn' + (lang?',':'') + lang;

                langConfApi.getAllLangConf({
                    form: {
                        langKey: self.langKey,
                        type: self.selectedType,
                        lang: lang
                    },
                    token: this.token
                }).then(res => {
                    this.rawData = res;
                    this.totalRow = res.length;
                })
            },
            getLangVersion() {
                let self = this;
                var lang = utils.getCookie('lang');
                langVersionApi.langVersionAll({
                    token: self.token,
                    lang: lang
                }).then(res => {
                    self.versionDataTable = res;
                    for (let index = 0; index < self.versionDataTable.length; index++) {
                        const element = self.versionDataTable[index];
                        element.lastTime = utils.formatDate(element.lastTime);
                    }
                })
            },
            downVersionJson(json) {
                console.log(json);
            },
            deleteVersion(version) {
                console.log(version);
                langVersionApi.deteLangVersion({
                    token: this.token,
                    version: version
                }).then(res => {
                    console.log(res);
                    this.versionDataTable = res;
                    for (let index = 0; index < this.versionDataTable.length; index++) {
                        const element = this.versionDataTable[index];
                        element.lastTime = utils.formatDate(element.lastTime);
                    }
                })
            },
            downloadExcel() {
                langConfApi.downloadExcel();
            },
            exportJson(scope) {
                let self = this;
                let langVal = scope.row.value;
                langConfApi.exportJson({
                    token: this.token,
                    lang: langVal
                }).then(res => {
                    self.jsonData = res;
                    const blob = new Blob([self.jsonData], {type: 'application/json'});
                    FileSaver.saveAs(blob, 'lang-' + langVal + '.json');


                    // 检查 res 是否为字符串
                    /*const jsonStr = typeof res === 'string' ? res : JSON.stringify(res, null, 2);
                    self.jsonData = jsonStr;
                    const blob = new Blob([jsonStr], {type: 'application/json'});
                    FileSaver.saveAs(blob, 'lang-' + langVal + '.json');*/
                })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lang_dialog/lang_conf.vue